var N = Object.defineProperty, x = Object.defineProperties;
var v = Object.getOwnPropertyDescriptors;
var l = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable;
var u = (t, a, e) => a in t ? N(t, a, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[a] = e, r = (t, a) => {
  for (var e in a || (a = {}))
    c.call(a, e) && u(t, e, a[e]);
  if (l)
    for (var e of l(a))
      d.call(a, e) && u(t, e, a[e]);
  return t;
}, y = (t, a) => x(t, v(a));
var m = (t, a) => {
  var e = {};
  for (var i in t)
    c.call(t, i) && a.indexOf(i) < 0 && (e[i] = t[i]);
  if (t != null && l)
    for (var i of l(t))
      a.indexOf(i) < 0 && d.call(t, i) && (e[i] = t[i]);
  return e;
};
import { jsxs as q, jsx as n } from "react/jsx-runtime";
import { forwardRef as Q } from "react";
import p from "../../../../node_modules/@faststore/components/dist/esm/molecules/IconButton/IconButton.js";
const A = Q(function(j, h) {
  var s = j, {
    quantity: a,
    testId: e = "store-quantity-selector",
    leftButtonProps: i,
    rightButtonProps: f,
    measureUnit: o
  } = s, b = m(s, [
    "quantity",
    "testId",
    "leftButtonProps",
    "rightButtonProps",
    "measureUnit"
  ]);
  return /* @__PURE__ */ q(
    "div",
    y(r({
      className: "quantity-selector",
      "data-testid": e,
      ref: h
    }, b), {
      children: [
        /* @__PURE__ */ n(
          p,
          r({
            "aria-controls": "quantity-selector-input",
            "aria-label": "Diminuir quantidade",
            className: "quantity-selector-button button-plus"
          }, i)
        ),
        /* @__PURE__ */ q("div", { style: { display: "flex", alignItems: "center" }, children: [
          /* @__PURE__ */ n("div", { style: { width: "auto" }, children: /* @__PURE__ */ n("p", { "aria-label": "Quantidade", className: "quantity-selector-quantity", children: a }) }),
          o && o !== "un" && /* @__PURE__ */ n("p", { className: "quantity-selector-measure-unit", children: o })
        ] }),
        /* @__PURE__ */ n(
          p,
          r({
            "aria-controls": "quantity-selector-input",
            "aria-label": "Aumentar quantidade",
            className: "quantity-selector-button quantity-selector-button-plus"
          }, f)
        )
      ]
    })
  );
});
export {
  A as default
};
